import React, { Component } from "react";
import { IVehicleBase } from "../classes/Domain";

interface IProps {
    vehicle: IVehicleBase
}

class VehicleTitle extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    formatTitle() {
        return `YOUR ${this.props.vehicle.year} ${this.props.vehicle.make} ${this.props.vehicle.model}`;
    }

    render() {
        return (
            <h5>{this.formatTitle()}</h5>
        );
    }
}

export default VehicleTitle;